<template>
	<div class="talent_pool">
		<div v-wechat-title="$route.meta.title"></div>
		<TopBar></TopBar>
		<div style="display: flex;justify-content: center; align-items: flex-start; margin-top: 20px;">
			<div style="min-height: 900px; width: 240px; background-color: #FFFFFF;">
				<Menu mode="vertical" active-name="filtrate" @on-select="menuListClick">
					<MenuItem name="filtrate">
					筛选
					</MenuItem>
					<MenuItem name="firstInterview">
					一面
					</MenuItem>
					<MenuItem name="secondInterview">
					二面
					</MenuItem>
					<MenuItem name="secondInterviewOk">
					二面已通过
					</MenuItem>
					<MenuItem name="positionManagement">
					岗位管理
					</MenuItem>
				</Menu>
			</div>
			<div style="width: 1350px;  background-color: #FFFFFF;margin-left: 20px; padding: 20px;">
				<FirstFiltrate v-show="menuName == 'filtrate'" :talentInfo="talentInfo" :positionFilter="positionFilter"></FirstFiltrate>
				<Interview v-show="menuName == 'firstInterview'" ref="firstInterview" :positionFilter="positionFilter"></Interview>
				<Interview v-show="menuName == 'secondInterview'" ref="secondInterview" :positionFilter="positionFilter"></Interview>
                <Interview v-show="menuName == 'secondInterviewOk'" ref="secondInterviewOk" :positionFilter="positionFilter"></Interview>
				<Position v-show="menuName == 'positionManagement'" ref="positionManagement" :positionInfos='positionInfos'></Position>
			</div>
		</div>
	</div>
</template>

<script>
	import TopBar from '../topbar/TopBar.vue'
	import FirstFiltrate from './FirstFiltrate.vue'
	import Interview from './Interview.vue'
	import InterviewPass from './InterviewPass.vue'
	import Position from './Position.vue'
    import {mapGetters} from 'vuex';
    import {
        getAllTalentInfo,getTalentSearchResult
    } from '@/api/talent.js';
    
	export default{
		name:"TalentPool",
        
        computed:{
            ...mapGetters(['userInfo', 'token']),
        },
		components:{TopBar,FirstFiltrate,Interview,InterviewPass,Position},
		data() {
			return {
				menuName:'filtrate',
                //进入岗位管理的默认数据
                positionInfos:[],
                talentInfo:[],
                positionFilter:[],
                //进入一面菜单的默认数据
                firstInterviewTalent:[],
                
                searchParam:{
                    
                },
			}
		},
        mounted: function () {
        	this.getAllTalentInfo({token:this.token});
        },
		methods:{
			menuListClick(e) {
				this.menuName = ''
				this.menuName = e
                switch (e){
                    //一面
                    case 'firstInterview':
                    this.$refs['firstInterview'].menuName = e;
                        this.$refs['firstInterview'].searchFilter.stage = ['first_interview'];
                        this.$refs['firstInterview'].searchFilter.status = [];
                        setTimeout(function () {
							this.$refs['firstInterview'].searchTalent();
						}, 500)
                    break;
                    //二面
                    case 'secondInterview':
                        this.$refs['secondInterview'].menuName = e;
                        this.$refs['secondInterview'].searchFilter.stage = ['second_interview'];
                        this.$refs['secondInterview'].searchFilter.status = [];
						setTimeout(function () {
							this.$refs['secondInterview'].searchTalent();
						}, 500)
                    break;
                    //二面已通过
                    case 'secondInterviewOk':
                        this.$refs['secondInterviewOk'].menuName = e;
                        this.$refs['secondInterviewOk'].searchFilter.stage = ['second_interview'];
                        this.$refs['secondInterviewOk'].searchFilter.status = [1];
						setTimeout(function () {
							this.$refs['secondInterviewOk'].searchTalent();
						}, 500)
                    break;
                    case 'positionManagement':
                        this.$refs['positionManagement'].getAllPositionInfo();
                    break;
                    
                }
			},
            getAllTalentInfo(data){
                let that = this
                getAllTalentInfo(data).then(function (res){
                    that.talentInfo = res.data.data
                });
            },
            
		}
	}
</script>

<style scoped lang="less">
	.talent_pool{
		min-width: 1920px;
		height: 100%;
		background-color: #F5F7F9 ;
	}
</style>
